var map = {
	"./de": "EMl2",
	"./de.js": "EMl2",
	"./en": "Wud9",
	"./en.js": "Wud9",
	"./fr": "zH1P",
	"./fr.js": "zH1P",
	"./kde": "DQ8Y",
	"./kde.js": "DQ8Y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Puz9";